import type { LOAN_APPLICATION_SUB_STATUS } from './index'

export enum SMART_LODGEMENT_ENGINE_STATUS {
  AWAITING_ASSESSMENT = 'AWAITING ASSESSMENT',
  SUBMISSION_COMPLETE = 'SUBMISSION COMPLETE',
  MANUAL_ASSESSMENT = 'MANUAL ASSESSMENT',
  ASSESSMENT_COMPLETE = 'ASSESSMENT COMPLETE',
  PROCESSING_ASSESSMENT = 'PROCESSING ASSESSMENT',
}

export interface SALESFORCE_DATA {
  subStatus: LOAN_APPLICATION_SUB_STATUS
  pinnedNotes: string
  additionalInformation: string
}

export enum SMART_LODGEMENT_ENGINE_STEP {
  READY_FOR_ASSESSMENT = 'Ready for Assessment',
  LENDER_POLICY = 'Lender Policy',
  ID_VERIFICATION = 'ID Verification',
  INCOME_VERIFICATION = 'Income Verification',
  LIABILITY_VERIFICATION = 'Liability Verification',
  SERVICING = 'Servicing',
  LODGEMENT = 'Lodgement',
}

export enum SMART_LODGEMENT_ENGINE_STAGE {
  READY_FOR_ASSESSMENT = 'Ready for Assessment',
  POLICY_RULES = 'Policy Rules',
  SERVICING = 'Servicing',
  LODGEMENT = 'Lodgement',
}
